import React, { useEffect } from 'react';
import './LegalPage.css';
import { useLocation } from 'react-router-dom';

const LegalPage = () => {
  const location = useLocation();

  // Function to scroll to section
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Handle hash on initial load and when hash changes
  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.replace('#', '');
      // Longer timeout to ensure page is fully rendered
      setTimeout(() => {
        scrollToSection(sectionId);
      }, 300);
    }
  }, [location.hash, location.pathname]);

  return (
    <div className="legal-page">
      {/* Header */}
      <header className="legal-header">
        <nav className="legal-nav">
          <a href="/" className="legal-logo">Clear&Bare</a>
          <ul className="legal-nav-links">
            <li><a href="/">Home</a></li>
            <li><a href="/shop">Shop</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </nav>
      </header>

      {/* Main Content */}
      <div className="legal-container">
        <h1 className="legal-page-title">Legal Information</h1>
        
        {/* Table of Contents */}
        <div className="legal-toc">
          <h3>Quick Navigation</h3>
          <ul>
            <li>
              <a href="#privacy-policy" onClick={(e) => { e.preventDefault(); scrollToSection('privacy-policy'); }}>
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="#terms-conditions" onClick={(e) => { e.preventDefault(); scrollToSection('terms-conditions'); }}>
                Terms & Conditions
              </a>
            </li>
            <li>
              <a href="#cancellation-refunds" onClick={(e) => { e.preventDefault(); scrollToSection('cancellation-refunds'); }}>
                Cancellation & Refunds
              </a>
            </li>
          </ul>
        </div>

        {/* Privacy Policy Section */}
        <section className="legal-section" id="privacy-policy">
          <h2 className="legal-section-title">Privacy Policy</h2>
          
          <p>
            This privacy policy sets out how CLEAR & BARE uses and protects any information that you give CLEAR & BARE when you visit their website and/or agree to purchase from them. CLEAR & BARE is committed to ensuring that your privacy is protected. Should we ask you to provide certain information by which you can be identified when using this website, and then you can be assured that it will only be used in accordance with this privacy statement. CLEAR & BARE may change this policy from time to time by updating this page. You should check this page from time to time to ensure that you adhere to these changes.
          </p>

          <h3>Information We Collect</h3>
          <p>We may collect the following information:</p>
          <ul>
            <li>Name</li>
            <li>Contact information including email address</li>
            <li>Demographic information such as postcode, preferences and interests, if required</li>
            <li>Other information relevant to customer surveys and/or offers</li>
          </ul>

          <h3>What We Do With the Information We Gather</h3>
          <p>We require this information to understand your needs and provide you with a better service, and in particular for the following reasons:</p>
          <ul>
            <li>Internal record keeping</li>
            <li>We may use the information to improve our products and services</li>
            <li>We may periodically send promotional emails about new products, special offers or other information which we think you may find interesting using the email address which you have provided</li>
            <li>From time to time, we may also use your information to contact you for market research purposes. We may contact you by email, phone, fax or mail</li>
            <li>We may use the information to customise the website according to your interests</li>
          </ul>

          <h3>Security</h3>
          <p>We are committed to ensuring that your information is secure. In order to prevent unauthorised access or disclosure we have put in suitable measures.</p>

          <h3>How We Use Cookies</h3>
          <p>A cookie is a small file which asks permission to be placed on your computer's hard drive. Once you agree, the file is added and the cookie helps analyze web traffic or lets you know when you visit a particular site. Cookies allow web applications to respond to you as an individual. The web application can tailor its operations to your needs, likes and dislikes by gathering and remembering information about your preferences.</p>

          <p>We use traffic log cookies to identify which pages are being used. This helps us analyze data about webpage traffic and improve our website in order to tailor it to customer needs. We only use this information for statistical analysis purposes and then the data is removed from the system.</p>

          <p>Overall, cookies help us provide you with a better website, by enabling us to monitor which pages you find useful and which you do not. A cookie in no way gives us access to your computer or any information about you, other than the data you choose to share with us.</p>

          <p>You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. This may prevent you from taking full advantage of the website.</p>

          <h3>Controlling Your Personal Information</h3>
          <p>You may choose to restrict the collection or use of your personal information in the following ways:</p>
          <ul>
            <li>Whenever you are asked to fill in a form on the website, look for the box that you can click to indicate that you do not want the information to be used by anybody for direct marketing purposes</li>
            <li>If you have previously agreed to us using your personal information for direct marketing purposes, you may change your mind at any time by writing to or emailing us at clearandbare.skincare@gmail.com</li>
          </ul>

          <p>We will not sell, distribute or lease your personal information to third parties unless we have your permission or are required by law to do so. We may use your personal information to send you promotional information about third parties which we think you may find interesting if you tell us that you wish this to happen.</p>

          <p>If you believe that any information we are holding on you is incorrect or incomplete, please write to Central Hanuman Rd Beed MAHARASHTRA 431515 or contact us at 8788631381 or clearandbare.skincare@gmail.com as soon as possible. We will promptly correct any information found to be incorrect.</p>
        </section>

        {/* Terms & Conditions Section */}
        <section className="legal-section" id="terms-conditions">
          <h2 className="legal-section-title">Terms & Conditions</h2>
          
          <p>For the purpose of these Terms and Conditions, The term "we", "us", "our" used anywhere on this page shall mean CLEAR & BARE, whose registered/operational office is Central Hanuman Rd Beed MAHARASHTRA 431515. "you", "your", "user", "visitor" shall mean any natural or legal person who is visiting our website and/or agreed to purchase from us.</p>

          <p>Your use of the website and/or purchase from us are governed by following Terms and Conditions:</p>

          <p>The content of the pages of this website is subject to change without notice.</p>

          <p>Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials found or offered on this website for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.</p>

          <p>Your use of any information or materials on our website and/or product pages is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services or information available through our website and/or product pages meet your specific requirements.</p>

          <p>Our website contains material which is owned by or licensed to us. This material includes, but are not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.</p>

          <p>All trademarks reproduced in our website which are not the property of, or licensed to, the operator are acknowledged on the website.</p>

          <p>Unauthorized use of information provided by us shall give rise to a claim for damages and/or be a criminal offense.</p>

          <p>From time to time our website may also include links to other websites. These links are provided for your convenience to provide further information.</p>

          <p>You may not create a link to our website from another website or document without CLEAR & BARE's prior written consent.</p>

          <p>Any dispute arising out of use of our website and/or purchase with us and/or any engagement with us is subject to the laws of India.</p>

          <p>We, shall be under no liability whatsoever in respect of any loss or damage arising directly or indirectly out of the decline of authorization for any Transaction, on Account of the Cardholder having exceeded the preset limit mutually agreed by us with our acquiring bank from time to time.</p>
        </section>

        {/* Cancellation & Refunds Section */}
        <section className="legal-section" id="cancellation-refunds">
          <h2 className="legal-section-title">Cancellation & Refunds</h2>
          
          <p>CLEAR & BARE believes in helping its customers as far as possible, and has therefore a liberal cancellation policy. Under this policy:</p>

          <p>Cancellations will be considered only if the request is made within 16-30 days of placing the order. However, the cancellation request may not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them.</p>

          <p>CLEAR & BARE does not accept cancellation requests for perishable items like flowers, eatables etc. However, refund/replacement can be made if the customer establishes that the quality of product delivered is not good.</p>

          <p>In case of receipt of damaged or defective items please report the same to our Customer Service team. The request will, however, be entertained once the merchant has checked and determined the same at his own end. This should be reported within 16-30 days of receipt of the products.</p>

          <p>In case you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within 16-30 days of receiving the product. The Customer Service Team after looking into your complaint will take an appropriate decision.</p>

          <p>In case of complaints regarding products that come with a warranty from manufacturers, please refer the issue to them.</p>

          <p>In case of any Refunds approved by the CLEAR & BARE, it'll take 16-30 days for the refund to be processed to the end customer.</p>
        </section>
      </div>
    </div>
  );
};

export default LegalPage;